 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Type of Packing
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryCargoPackFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryCargoPackFilterForm"
                            v-model="filtersCargoPack.id"
                            :label="filtersCargoPackLabel.id"
                            :error-messages="errors.collect('id')"
                            data-vv-name="id"
                            :data-vv-as="filtersCargoPackLabel.id"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearCargoPackFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doCargoPackFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="cargoComdtyHeaders"
          :items="cargoPackItems"
          v-bind:options.sync="paginationCargoPack"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsCargoPack"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.pack }}</td>
              <td>{{ row.item.packDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignCargoPack(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersCargoPackLabel: {
        id: 'Packing'
      },
      filtersCargoPack: {
        id: undefined,
        pack: undefined,
        packDesc: undefined
      },
      cargoPackItems: [],
      totalItemsCargoPack: 0,
      cargoComdtyHeaders: [
        { text: 'Packing', align: 'left', value: 'pack' },
        { text: 'Description', value: 'packDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationCargoPack: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearCargoPackFilters()
  },
  methods: {
    closeDialog() {
      this.resetFilterForm()
      this.$emit('close')
    },
    doClearCargoPackFilters() {
      this.resetFilterForm()
      this.fetchCargoPackData()
    },
    doCargoPackFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryCargoPackFilterForm').then((result) => {
        if (result) {
          this.paginationCargoPack.page = 1
          this.fetchCargoPackData()
        }
      })
    },
    resetFilterForm() {
      this.filtersCargoPack.id = ''
      this.filtersCargoPack.comdty = ''
      this.filtersCargoPack.packDesc = ''
    },
    assignCargoPack(data) {
      this.$emit('assign-cargo-pack-val-info', data)
      this.$emit('close')
    }
  },
  computed: {},
  watch: {
    'paginationCargoPack': function (value) {
      this.fetchCargoPackData()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin],
  props: {}
}
</script>
